var map = {
	"./Results-Graph_TextureYellow-simple-SMALLER-FOR-MOBILE.svg": 3182,
	"./Results-Graph_TextureYellow-simple.svg": 5580,
	"./chart-nav-btn-hover.svg": 1977,
	"./chart-nav-btn.svg": 9221,
	"./icon-content.svg": 5516,
	"./icon-report.svg": 5557,
	"./line-20.svg": 6917,
	"./tbnail-01.png": 2853,
	"./tbnail-02.png": 2949,
	"./tbnail-03.png": 2924,
	"./tbnail-04.png": 4618,
	"./web-solo.svg": 2435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;